import { MODAL_TYPE_SHARE_POST } from '@wix/communities-blog-client-common/dist/src/constants/modal-types';

export const BUTTON_CREATE_POST = 'create_post';
export const BUTTON_ACTION_CLICK = 'action_click';
export const BUTTON_SHARE_POST_MODAL = MODAL_TYPE_SHARE_POST;
export const BUTTON_SHARE_POST = 'share_post';
